/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: Partial<Assessment>, schemaOptions: { partial: true })
 */
export interface AssessmentPartial { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    id?: string;
    title?: string;
    description?: string;
    instructions?: string;
    assessmentType?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    hideParticipantIdentity?: boolean;
    allowMultipleResponses?: boolean;
    showResultsToParticipants?: boolean;
    requireLogin?: boolean;
    maxResponses?: number;
    useCompanyParticipants?: boolean;
    companyId?: string;
}

